import React from "react";
import CustomTable from "../CustomTable";

const CustomPageTable = ({
  data,
  columns,
  pageSize,
  loading,
  getTrProps,
  classTable = "table-react",
  flexiableDefaultColsWidth,
  isExportCSV,
  setIsExportCSV,
  pageName,
  style,
  useCusomCol,
  paginationText,
  isSmallSize,
}) => {
  return (
    <CustomTable
      className={classTable}
      pageSize={pageSize}
      columns={columns}
      dataSource={data}
      loading={loading}
      getTrProps={getTrProps}
      flexiableDefaultColsWidth={flexiableDefaultColsWidth}
      isExportCSV={isExportCSV}
      setIsExportCSV={setIsExportCSV}
      pageName={pageName}
      style={style}
      useCusomCol={useCusomCol}
      paginationText={paginationText}
      isSmallSize={isSmallSize}
    />
  );
};

export default CustomPageTable;
